import { MutationTree } from 'vuex'
import { ItemState } from './bulk-actions.types'

export enum MutationTypes {
  SELECT_ITEM = 'SELECT_ITEM',
  UNSELECT_ITEM = 'UNSELECT_ITEM',
  SELECT_ALL = 'SELECT_ALL',
  UNSELECT_ALL = 'UNSELECT_ALL'
}

export const mutations: MutationTree<ItemState> = {
  [MutationTypes.SELECT_ITEM](state, id) {
    state.selectedIds.push(id)
  },
  [MutationTypes.UNSELECT_ITEM](state, id) {
    const deletedItemIndex = state.selectedIds.findIndex(item => item === id)
    state.selectedIds.splice(deletedItemIndex, 1)
  },
  [MutationTypes.SELECT_ALL](state, allItems) {
    state.selectedIds = allItems
  },
  [MutationTypes.UNSELECT_ALL](state) {
    state.selectedIds = []
  }
}
